import { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import api from "@/api/api.js";

const ConstanciaActions = ({ companyId, statusOnly = false }) => {
  const [cert, setCert] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    let active = true;
    setLoading(true);
    api
      .get(`/companies/${companyId}/certificateTax/latest`)
      .then(({ data }) => active && setCert(data))
      .catch(() => active && setCert(null))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [companyId]);

  const fetchBlobUrl = async () => {
    const { data } = await api.get(
      `/companies/${companyId}/certificateTax/${cert.id}/download`,
      { responseType: "blob" },
    );
    return window.URL.createObjectURL(
      new Blob([data], { type: "application/pdf" }),
    );
  };

  const handleView = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const url = await fetchBlobUrl();
      window.open(url, "_blank", "noopener");
    } catch {
      /* noop */
    } finally {
      setBusy(false);
    }
  };

  const handleDownload = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const url = await fetchBlobUrl();
      const a = document.createElement("a");
      a.href = url;
      a.download = cert.fileIdentifier || "constancia.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      /* noop */
    } finally {
      setBusy(false);
    }
  };

  if (loading) return <Spinner animation="border" size="sm" />;

  if (statusOnly)
    return (
      <span className={`badge bg-${cert ? "success" : "secondary"}`}>
        Constancia: {cert ? "Sí" : "No"}
      </span>
    );

  if (!cert)
    return (
      <span className="text-muted">Sin constancia de situación fiscal.</span>
    );

  return (
    <div className="d-flex gap-2 flex-wrap">
      <Button
        size="sm"
        variant="outline-primary"
        onClick={handleView}
        disabled={busy}
      >
        <i className="bi bi-eye me-1" />
        Ver constancia
      </Button>
      <Button
        size="sm"
        variant="outline-success"
        onClick={handleDownload}
        disabled={busy}
      >
        <i className="bi bi-download me-1" />
        Descargar constancia
      </Button>
    </div>
  );
};

export default ConstanciaActions;
